import { Appointment, CreateAppointmentDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";
import { workOrderKeys } from "src/entities/work-order";
import { scheduleKeys } from "src/entities/schedule";

export function useCreateAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: CreateAppointmentDto) => {
      const { data } = await appointmentApi.create(dto);
      return data as Appointment;
    },
    onSuccess: (_data, dto) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      queryClient.invalidateQueries({ queryKey: workOrderKeys.detail(dto.workOrderId) });
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(dto.workOrderId) });
    },
  });
}
